import { render } from "./app-icon-empty-tax.vue?vue&type=template&id=0482a8fa"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-empty-tax.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0482a8fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0482a8fa', __exports__)) {
    console.log('reload')
    api.reload('0482a8fa', __exports__)
  }
  
  module.hot.accept("./app-icon-empty-tax.vue?vue&type=template&id=0482a8fa", () => {
    console.log('re-render')
    api.rerender('0482a8fa', render)
  })

}


export default __exports__